determineAward.classy.controller({
    name: 'DetermineAwardController',
    inject: ['$scope', '$filter', 'ApplicationService', 'FamilyThresholdsService', 'CalculationService', 'PermissionModelService', 'ApplicationsSubNavbarService', 'authServiceFactory', 'SchoolModelService', 'AwardLettersModalService', 'MainContentService', 'DetermineAwardService', 'SliderService'],
    init: function ()
    {
        this.$.$sce = this.$sce;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.DetermineAwardService = this.DetermineAwardService;
        this.$.MainContentService = this.MainContentService;
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;
        this.$.AwardLettersModalService = this.AwardLettersModalService;
        this.$.authServiceFactory = this.authServiceFactory;
        if (!this.DetermineAwardService.flag) this.DetermineAwardService.resetAwardComplete();
        this.$.tabs = [
            {title: 'Recommended Award', url: 'recommendedAward'},
            {title: 'Calculated Award', url: 'calculatedAward'}
        ];
        this.DetermineAwardService.setActiveTab(this.$.tabs[0]);
        this.$.overOpen = false;  
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;
    },
    tuitionTooltip: function()
    {
        var content = '<table>';
        for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
            var num = parseInt(this.ApplicationService.getAwardData().applicants[i].App_Tuition) || 0 //to account for possible blank tuitions
            if (this.$.schoolinfo.Anonymous != 2)
            {
                content += '<tr><td>'+this.getField(this.ApplicationService.getAwardData().applicants[i], 'App_First') + '</td><td>&nbsp $' + this.$filter('number')(num, 0) + '</td></tr>';
            }
            if (this.$.schoolinfo.Anonymous == 2)
            {
                content += '<tr><td> Applicant '+ (i + 1) + '</td><td>&nbsp $' + this.$filter('number')(num, 0) + '</td></tr>';
            }
        }
        content += '</table>';
        return content;
    },
    closeAward: function(closeSlider)
    {
        this.DetermineAwardService.setAwardComplete('active');
        if (closeSlider == true) {
            this.SliderService.closeSlider(0);
        }
        /*if (path==0 || path==undefined)
            this.MainContentService.setActiveDiv('determineAward'); */
    },
    percentAdjust: function(fam)
    {
        if (fam == 0) {
            this.ApplicationService.getAwardData().family[1].thresholds.Thresh_Fam2_Tuition_Percent = 100 - this.ApplicationService.getAwardData().family[0].thresholds.Thresh_Fam1_Tuition_Percent;
        }
        else if (fam == 1) {
            this.ApplicationService.getAwardData().family[0].thresholds.Thresh_Fam1_Tuition_Percent = 100 - this.ApplicationService.getAwardData().family[1].thresholds.Thresh_Fam2_Tuition_Percent;
        }
        this.CalculationService.reCalc();
    },
    setOverContainer: function(bool)
    {
        if (this.PermissionModelService.get(this.authServiceFactory.getAuth().schoolID)[0].readOnly==0) {
            this.$.overOpen = bool;
        }
    },
    familyPut: function()
    {
        this.$.putObject = this.ApplicationService.getAwardData().family[0].thresholds;
        this.$.putObject.applicationID = this.ApplicationService.getAwardData().app[0].applicationID;
        this.FamilyThresholdsService.put(this.$.putObject);
        this.$.putObject = this.ApplicationService.getAwardData().family[1].thresholds;
        this.$.putObject.applicationID = this.ApplicationService.getAwardData().app[0].applicationID;
        this.FamilyThresholdsService.put(this.$.putObject);
        this.setOverContainer(false);
    },
    getField: function(item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field] 
        else
            return item['x' + field];
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY');
    }
});

determineAward.service('DetermineAwardService', function(ApplicationService) {
    var awardComplete = false;
    var activeTab = 1;
    var tabs = [
            {title: 'Recommended Award', url: 'recommendedAward'},
            {title: 'Calculated Award', url: 'calculatedAward'}
        ]; 

    this.getAwardComplete = function()
    {
        return awardComplete;
    }
    this.setAwardComplete = function(awardType)
    {
        awardComplete = awardType;
    }
    this.getActiveTab = function()
    {
        return tabs[activeTab].url;
    }
    this.setActiveTab = function(tab)
    {
        activeTab = tab;
    }
    this.resetAwardComplete = function()
    {
        if (ApplicationService.getAwardData().app[0].Status_Award == "1")
        {
            let totalAward = 0;
            for (let i = 0; i < ApplicationService.getAwardData().applicants.length; i++)
                totalAward += parseInt(ApplicationService.getAwardData().applicants[i].ActAward);
            if (totalAward > 0)
                awardComplete = "Award";
            else
                awardComplete = "Reject";
        }
        else if (ApplicationService.getAwardData().app[0].Status_Consider == "1")
            awardComplete = "Consider";
        else if (ApplicationService.getAwardData().app[0].Status_Reject == "1")
            awardComplete = "Reject";
        else 
            awardComplete = "active";

        return this.getAwardComplete();
    }
});
